// TODO: tipar
let timerId: any = undefined;

// TODO: tipar
export const useAlgoliaDebounce = (query: any, search: any) => {
  if (timerId) {
    clearTimeout(timerId);
  }

  timerId = setTimeout(() => search(query), 200);
};
